import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth';

export const routes: Routes = [
  { 
    path: '', 
    redirectTo: 'content-management/food', 
    pathMatch: 'full' 
  },
  {
    path: 'content-management/food',
    loadComponent: () => import('./features/content-management/components/food/food').then(m => m.FoodComponent),
     canActivate: [authGuard],
  },
  {
    path: 'content-management/exercise',
    loadComponent: () => import('./features/content-management/components/exercise/exercise').then(m => m.ExerciseComponent),
     canActivate: [authGuard],
  },
  {
    path: 'content-management/mental-health',
    loadComponent: () => import('./features/content-management/components/mental-health/mental-health').then(m => m.MentalHealthComponent),
     canActivate: [authGuard],
  },
  {
    path: 'content-management/emotional-wellbeing',
    loadComponent: () => import('./features/content-management/components/emotional-wellbeing/emotional-wellbeing').then(m => m.EmotionalWellbeingComponent),
     canActivate: [authGuard],
  },
  {
    path: 'content-management/sleep',
    loadComponent: () => import('./features/content-management/components/sleep/sleep').then(m => m.SleepComponent),
     canActivate: [authGuard],
  },  
  {
    path: 'content-management/fasting',
    loadComponent: () => import('./features/content-management/components/fasting/fasting').then(m => m.FastingComponent),
     canActivate: [authGuard],
  },
  {
    path: 'content-management/sun-light',
    loadComponent: () => import('./features/content-management/components/sun-light/sun-light').then(m => m.SunLightComponent),
     canActivate: [authGuard],
  },
  {
    path: 'content-management/water',
    loadComponent: () => import('./features/content-management/components/water/water').then(m => m.WaterComponent),
     canActivate: [authGuard],
  },
  {
    path: 'reporting',
    loadComponent: () => import('./features/reporting/components/reporting').then(m => m.ReportingComponent),
     canActivate: [authGuard],
  },
  {
    path: 'reporting/total-scores',
    loadComponent: () => import('./features/reporting/components/reporting-total-scores').then(m => m.ReportingTotalScoresComponent),
     canActivate: [authGuard],
  },
  {
    path: 'initFirebase',
    loadComponent: () => import('./shared/components/InitFirebase').then(m => m.InitFirebase),
     canActivate: [authGuard],
  },
  {
    path: 'users',
    loadComponent: () => import('./features/users/components/users').then(m => m.UsersComponent),
     canActivate: [authGuard],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/pages/login/login').then(m => m.Login),
  }, 
  {
    path: 'settings/sub-category',
    loadComponent: () => import('./features/settings/components/food-types').then(m => m.FoodTypesComponent),
     canActivate: [authGuard],
  },   
];
